if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.isWithProductOptions = false;

      this.domChange = new CustomEvent('domChangeOnAddToCart', {
        bubbles: true
      });
      
      this.stickHeader = new CustomEvent('stickHeader', {
        bubbles: true
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if(this.classList.contains('product-with-options-addtocart')) {
        this.isWithProductOptions = true;
      }
      else{
        this.isWithProductOptions = false;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        })
        .then(() => {
          if(this.classList.contains('js-product-options-form')){
            this.querySelector('button').setAttribute("disabled", "");
            this.querySelector('.js-product-text').classList.add('hidden');
            this.querySelector('.js-product-added').classList.remove('u-none');

            fetch(`${window.location.pathname}?section_id=panel-cart-product-options`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const idPanelFooter = "panel-cart-product-footer-updatable"
                const destinationPanelFooter = document.getElementById(idPanelFooter);
                const sourcePanelFooter = html.getElementById(idPanelFooter);
                if (sourcePanelFooter && destinationPanelFooter) destinationPanelFooter.innerHTML = sourcePanelFooter.innerHTML;
              })
              .catch((e) => {
                console.error(e);
              })
          }
          const variantId = this.form.querySelector('input[name="id"]').value;
          if(this.isWithProductOptions === true) {
            return fetch(`${this.dataset.url}?variant=${variantId}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const idProductReco =  `product-options-list-${variantId}`;                
                const destinationProductReco = document.querySelector('.js-panel').querySelector('.product-options-list');
                const sourceProductReco = html.getElementById(idProductReco);
                if (sourceProductReco && destinationProductReco) destinationProductReco.innerHTML = sourceProductReco.innerHTML;

                const idPanelFooter = "panel-cart-product-footer-updatable"
                const destinationPanelFooter = document.getElementById(idPanelFooter);
                const sourcePanelFooter = html.getElementById(idPanelFooter);
                if (sourcePanelFooter && destinationPanelFooter) destinationPanelFooter.innerHTML = sourcePanelFooter.innerHTML;

                const idMiniCart =  "shopify-section-mini-cart";
                const destinationMiniCart = document.getElementById(idMiniCart);
                const sourceMiniCart = html.getElementById(idMiniCart);
                if (sourceMiniCart && destinationMiniCart) destinationMiniCart.innerHTML = sourceMiniCart.innerHTML;

                const destinationHeaderCartCount = document.getElementById('cart-item-count-in-header');
                const sourceHeaderCartCount = html.getElementById('cart-item-count-for-header'); 
                if (destinationHeaderCartCount && sourceHeaderCartCount) destinationHeaderCartCount.innerHTML = sourceHeaderCartCount.innerHTML;

                let isEmptyList = false
                if(html.getElementById("panel-cart-product-empty")){
                  isEmptyList = true
                }

                return isEmptyList
              })
              .then((isEmptyList) => {
                this.dispatchEvent(this.domChange); 

                if(isEmptyList){
                  this.dispatchEvent(this.stickHeader);
                  document.querySelector('.js-mini-cart').classList.add('mini-cart-active');
                  setTimeout(function() {
                    document.querySelector('.js-mini-cart').classList.remove('mini-cart-active');
                  }, 3500);
                }
                else{
                  document.querySelector('.js-open-panel-cart-product-options').click();
                }
              })
              .catch((e) => {
                console.error(e);
              })
          }
          else {
            return fetch(`${this.dataset.url}?variant=${variantId}&section_id=mini-cart`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const id = "shopify-section-mini-cart"
                      const html = new DOMParser().parseFromString(responseText, 'text/html')
                      const destination = document.getElementById(id);
                      const source = html.getElementById(id);
                      if (source && destination) destination.innerHTML = source.innerHTML;

                      const destinationHeaderCartCount = document.getElementById('cart-item-count-in-header');
                      const sourceHeaderCartCount = html.getElementById('cart-item-count-for-header'); 
                      if (destinationHeaderCartCount && sourceHeaderCartCount) destinationHeaderCartCount.innerHTML = sourceHeaderCartCount.innerHTML;

                      return
                    })
                    .then(() => {
                      this.dispatchEvent(this.stickHeader);
                      this.dispatchEvent(this.domChange);
                      document.querySelector('.js-mini-cart').classList.add('mini-cart-active');
                      setTimeout(function() {
                        document.querySelector('.js-mini-cart').classList.remove('mini-cart-active');
                      }, 3500);
                    })
                    .catch((e) => {
                      console.error(e);
                    });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
